export enum StatusEnum {
  ASSIGNED = 'Assigned',
  COMPLETED = 'Completed',
  INPROGRESS = 'In-progress',
  OVERDUE = 'Overdue',
  WRAP_UP = 'Wrap Up',
  PENDING = 'Pending',
  READY = 'Ready',
  UNASSIGNED = 'Unassigned',
  NULL_STATUS = '',
}
